import React from 'react';
import {Link} from 'react-router-dom'
import logo from '../../images/logo/logo.webp'
import mida_logo from '../../images/mida_logo.jpg'

import './style.css'

const FooterSection = () => {

    return(
        <div className="wpo-footer-area bg-gray-800 py-8">
            <div className="container mx-auto">
                <div className="flex flex-col items-center text-center gap-4">
                    {/* Logo */}
                    {/*<div>*/}
                    {/*    <img src={logo} alt="Logo" className="h-20" />*/}
                    {/*</div>*/}
                    <span className="text-white text-lg">Follow us here:</span>
                    <ul className="flex gap-2">
                        <li>
                            <Link to="/" className="text-white text-2xl hover:text-blue-500">
                                <i className="fa fa-facebook" aria-hidden="true"></i>
                            </Link>
                        </li>
                        <li>
                            <Link to="/" className="text-white text-2xl hover:text-blue-500">
                                <i className="fa fa-twitter" aria-hidden="true"></i>
                            </Link>
                        </li>
                        <li>
                            <Link to="/" className="text-white text-2xl hover:text-blue-500">
                                <i className="fa fa-linkedin" aria-hidden="true"></i>
                            </Link>
                        </li>
                    </ul>

                    {/* Copyright Text */}
                    <div>
                <span className="text-gray-400 text-sm">
                    © Copyrights 2025. All Rights Reserved.
                </span>
                    </div>
                </div>
            </div>
        </div>

     )
        
}

export default FooterSection;
